import { Modal, CardHeader, CardTitle, CardBody, CardFooter, Button, Card, Row, Col } from 'reactstrap';
import Countdown from "react-countdown";
import React from 'react';
import moment from 'moment';
// import this.props.web3 from '../ethereum/this.props.web3';
import Loader from "react-loader-spinner";

export default class WrongAnswer extends React.Component {
    render() {
        const { isOpen, toggleOpen } = this.props;
        return (
            <Modal isOpen={isOpen} toggle={toggleOpen} modalClassName="modal-login" backdrop={true} style={{ zIndex: 10000 }}>
                <Card className="card-swap">
                    <CardHeader>
                        <CardTitle tag="h4">
                            <div className="icon-big icon-flame" style={{ display: 'flex' }}>
                                <div style={{ marginTop: '10px', marginLeft: '20px' }}>
                                    <h1 className="text-danger text-head">
                                        <strong>Wrong Answer</strong></h1>
                                </div>
                            </div>
                        </CardTitle>
                        <button
                            style={{ zIndex: 10000 }}
                            aria-label="Close"
                            className="close"
                            data-dismiss="modal"
                            type="button"
                            onClick={toggleOpen}
                        >
                            <i className="tim-icons icon-simple-remove text-earth" />
                        </button>
                    </CardHeader>
                    <CardBody>
                        <div>
                            <p className="text-earth text-hl text-center">
                                Please try again!<br></br>
                            </p>
                        </div>
                    </CardBody>
                    <CardFooter className="text-center ">
                        <Button
                            block
                            className="btn-round"
                            color="danger"
                            onClick={toggleOpen}
                            size="lg"
                        >
                            OK!
                            </Button>
                    </CardFooter>
                </Card>
            </Modal>)
    }
}